import createIcon from '../../createIcon';

/**
 * @component @name AccountCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMiA2QzEzLjkzIDYgMTUuNSA3LjU3IDE1LjUgOS41QzE1LjUgMTEuNDMgMTMuOTMgMTMgMTIgMTNDMTAuMDcgMTMgOC41IDExLjQzIDguNSA5LjVDOC41IDcuNTcgMTAuMDcgNiAxMiA2Wk0xMiAyMEM5Ljk3IDIwIDcuNTcgMTkuMTggNS44NiAxNy4xMkM3LjU1IDE1LjggOS42OCAxNSAxMiAxNUMxNC4zMiAxNSAxNi40NSAxNS44IDE4LjE0IDE3LjEyQzE2LjQzIDE5LjE4IDE0LjAzIDIwIDEyIDIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountCircle = createIcon('AccountCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM12 20C9.97 20 7.57 19.18 5.86 17.12C7.55 15.8 9.68 15 12 15C14.32 15 16.45 15.8 18.14 17.12C16.43 19.18 14.03 20 12 20Z',
      key: '1uol2h',
    },
  ],
]);

export default AccountCircle;
